/**
 * Created by Thomas Mark
 * Date: 2019-10-29
 * 
 * Icons verwalten
 * 
 * In diesem Dialog können alle Icons in einer Liste angezeigt,
 * erstellt, geändert oder gelöscht werden.
 * 
 * Der Dialog kann nur durch einen Administrator gestartet werden.
 * 
 * Änderungen werden auf dem Server in der Datei 'icons.json' gespeichert.
 * 
 */
import React from 'react';
import { connect } from "react-redux"
import { Redirect } from 'react-router-dom';
import { bindActionCreators } from "redux";

import DeleteIcon from '@material-ui/icons/Delete';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';

import IconModal from "./IconModal";
import WebsiteModal from "../sites/WebsiteModal";
import Header from "../../partials/Header";
import Footer from "../../partials/Footer";

import * as appActions from "../../../store/actions/appActions";
import * as iconActions from '../../../store/actions/iconActions';

class IconsController extends React.Component {
    constructor(props) {
        super(props);

        this.component = 'IconsController'

        this.state = {
            tabIndex: 2
        }
    }

    // ==========================================================================
    //
    // LIFESYCLE - SECTION
    //
    // ==========================================================================

    componentDidMount = () => {
        const debug = false;

        debug && console.log(`\n\n##################################################`);
        debug && console.log(`${this.component}:Mount`);
        debug && console.log(`##################################################\n\n`);

        this.props.setModalDialog(null, null)

        this.props.getIconList();
    }

    componentWillUnmount = () => {
        const debug = false;

        debug && console.log(`\n\n##################################################`);
        debug && console.log(`${this.component}:Unmount`);
        debug && console.log(`##################################################\n\n`);
    }

    // ==========================================================================
    //
    // RENDER - SECTION
    //
    // ==========================================================================
    render() {
        const { inputHeight, currentContainer } = this.props.app;
        const { loginUser } = this.props.user;
        const { iconList } = this.props.icon;


        const columns = [
            { id: 'svg', label: 'Icon', minWidth: 10, align: 'left' },
            { id: 'id', label: 'ID', minWidth: 50, align: 'left' },
            { id: 'type', label: 'Typ', minWidth: 50, align: 'left' },
            { id: 'label', label: 'Bezeichnung', minWidth: 230, align: 'right' },
            { id: 'unit', label: 'Einheit', minWidth: 50, align: 'center' },
            { id: 'value', label: 'Wert', minWidth: 50, align: 'center' },
            { id: 'edit', label: '', minWidth: 0, align: 'right' },

        ];

        const onCreate = () => {
            const newIcon = { id: "", type: "", label: "", unit: "", value: "" };
            this.props.initIcon(newIcon, 'IconModal');
        }

        const renderHead = () => {

            const getCellValue = (column) => {

                if (column.id === 'edit') {
                    return (<Button variant="contained" color="primary" size="large" startIcon={<AddIcon />} onClick={onCreate}>Neu</Button>)
                }
                return column.label
            }

            return (
                <TableRow>
                    {columns.map((column) => (
                        <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                            {getCellValue(column)}
                        </TableCell>
                    ))}
                </TableRow>
            )
        }

        const renderItem = (d, i) => {

            const onClick = (column, d) => {
                if (column.id !== 'edit') {
                    this.props.getIcon(d.id);
                }
            }

            const onEdit = (d, crudType) => {
                this.props.getIcon(d.id, 'IconModal', crudType)
            }

            const getCellValue = (column, d, i) => {
                const value = d[column.id];

                if (column.id === 'edit') {
                    return (
                        <div className="space-x-8">
                            <EditIcon onClick={() => onEdit(d, 'update')} />
                            <DeleteIcon onClick={() => onEdit(d, 'delete')} />
                        </div>
                    )
                }

                if (column.id === 'svg') {
                    if (value === '') return null;

                    const src = URL.createObjectURL(new Blob([value], { type: 'image/svg+xml' }));

                    return (<img src={src} width={32} height={32} title="x" alt="" />)
                }

                if (column.format && typeof value === 'number') return column.format(value)
                if (column.format && column.id === 'timestamp') return column.format(value)

                return value
            }

            return (
                <TableRow hover role="checkbox" key={i} >
                    {columns.map((column) => {
                        return (
                            <TableCell key={column.id} align={column.align} onClick={() => onClick(column, d)}>
                                {getCellValue(column, d, i)}
                            </TableCell>
                        );
                    })}
                </TableRow>
            );
        }

        const renderTable = (roleList) => {

            if (!iconList.length) {

                return (
                    <Typography className="p-8" variant="h6" >
                        Keine Datensätze vorhanden!
                        <br />
                        <Button
                            variant="contained"
                            color="primary"
                            size="large"
                            startIcon={<AddIcon />}
                            onClick={onCreate}
                        >
                            Neu
                        </Button>
                    </Typography>
                )
            }

            return (
                <TableContainer className={"w-full"} style={{ height: inputHeight, bottom: 0 }}>
                    <Table stickyHeader >
                        <TableHead>
                            {renderHead()}
                        </TableHead>
                        <TableBody>
                            {iconList && iconList.map((d, i) => renderItem(d, i))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )
        }

        // ==========================================================================
        // 
        // MAIN RENDER
        // 
        // ==========================================================================

        // Prüfen, ob der Dialog ausgeführt werden darf
        if (currentContainer === '' || !loginUser || loginUser.role !== 'Admin') {
            console.log(`\n${this.component}: !loginUser -> redirect to /\n\n`);
            return <Redirect to='/' />
        }

        if (!iconList) return null;

        return (
            <div className={"IconsController w-full h-full flex flex-col"}>
                <Header />
                {renderTable()}
                <Footer />
                <IconModal />
                <WebsiteModal />
            </div>
        );
    }
}
function mapStateToProps(state) {
    return {
        app: state.app,
        user: state.user,
        icon: state.icon,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions, iconActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(IconsController);